module.exports = __webpack_public_path__ + "img/Frame4314.8f8da514.png";